import { ui } from '../../data/ui';
import { SectionHeader } from '../ui/SectionHeader';
import { ScrollReveal } from '../ui/ScrollReveal';
import { Button } from '../ui/Button';
import './AIEngineering.css';

const aiFocusAreas = [
  { title: ui.aiFocus.localRag.title, description: ui.aiFocus.localRag.description, icon: '🔍' },
  { title: ui.aiFocus.aiAgents.title, description: ui.aiFocus.aiAgents.description, icon: '🤖' },
  { title: ui.aiFocus.semanticLayers.title, description: ui.aiFocus.semanticLayers.description, icon: '🧬' },
  { title: ui.aiFocus.knowledgeRetrieval.title, description: ui.aiFocus.knowledgeRetrieval.description, icon: '📚' },
];

export function AIEngineering() {
  return (
    <section className="section ai-section" id="ai">
      <div className="bg-glow ai-glow" />
      <div className="container">
        <SectionHeader
          label={ui.sections.currentFocus}
          title={ui.sections.aiEngineering}
          subtitle={ui.sections.aiEngineeringSub}
        />

        <ScrollReveal className="ai-intro glass-card">
          <p>{ui.aiFocus.intro}</p>
        </ScrollReveal>

        <div className="ai-grid">
          {aiFocusAreas.map((area, i) => (
            <ScrollReveal key={area.title} delay={i * 0.1}>
              <div className="ai-card glass-card">
                <span className="ai-card-icon">{area.icon}</span>
                <h3>{area.title}</h3>
                <p>{area.description}</p>
              </div>
            </ScrollReveal>
          ))}
        </div>

        <div className="section-cta">
          <Button to="/services" variant="ghost">
            {ui.sections.viewAiEstimates} <span className="arrow">←</span>
          </Button>
        </div>
      </div>
    </section>
  );
}
